/**
 * OrderSummaryStatics
 * --
 */
import React, { useState } from 'react';
import { Content, Statistic } from 'components';
import { Tag } from 'antd';
import { stringToMoneyFormat } from 'utils';
import moment from 'moment';

import {
  PAYMENT_METHOD_CONSTANT, // 주문 유형
  PAYMENT_STATUS_CONSTANT, // 주문의 결제상태
  PRODUCT_TYPE, // 상품유형
  PACKAGING_METHOD, // 포장방식
  // PRODUCT_STATUS, //상품 판매 상태
  // APPLICATION_STATUS, // 상품 등록 승인여부
  // TAX_TYPE, // 과세유형
} from 'constants/ProductConstants';

/**----------------------------------------
 * [Component] 필터
 * ----------------------------------------
 */
const OrderSummaryStatics = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { totalCount, totalPrice, totalDiscount, refundPrice, refundCount } =
    props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content
        fullWidth
        padding={0}
        backgroundColor={'none'}
        style={{
          marginBottom: 4,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {[
          {
            title: '총 주문건',
            value: stringToMoneyFormat(totalCount ?? 0),
            suffix: '건',
          },
          {
            title: '총 주문금액',
            value: stringToMoneyFormat(totalPrice ?? 0),
            suffix: '원',
          },
          {
            title: '실제결제금액',
            value: stringToMoneyFormat(
              (totalPrice ?? 0) - (totalDiscount ?? 0) - (refundPrice ?? 0) ?? 0
            ),
            suffix: '원',
          },
          {
            title: '환불',
            value: stringToMoneyFormat(refundCount ?? 0),
            suffix: '건',
          },
          {
            title: '환불금액',
            value: stringToMoneyFormat(refundPrice ?? 0),
            suffix: '원',
          },
        ].map((_item, _index) => (
          <div
            key={`${_item.label}-${_index}`}
            className="boxShadow"
            style={{
              background: '#FFFFFF',
              borderRadius: 4,
              width: `90%`,
              // width: `calc(100% / 3)`,
              // marginRight: _index === 7 ? 0 : 4,
              margin: '0 2px',
              padding: '24px 15px',
            }}
          >
            <Statistic
              title={_item.title}
              value={_item.value}
              suffix={_item.suffix}
              direction={'row'}
              style={{ justifyContent: 'center' }}
            />
          </div>
        ))}
      </Content>
    </>
  );
};

export default OrderSummaryStatics;
